"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const Container = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  width: "100%"
}));
const HeaderContainer = styled(Box)(({}) => ({}));
const AccordionSectionContainer = styled(Box)(() => ({
  paddingBottom: SpaceMd
}));
export {
  AccordionSectionContainer,
  Container,
  HeaderContainer
};
